module.exports = __webpack_public_path__ + "static/img/COC2023-35.d53914c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-35.png
// module id = sk3+
// module chunks = 0